import { makeStyles } from '@material-ui/core/styles';
import typography from '@/theme/typography';
import { BackgroundColors } from '@/utils/constants';

const useStyles = makeStyles(
  (muiTheme) => ({
    jumplinks: {
      [muiTheme.breakpoints.up('md')]: {
        marginTop: muiTheme.spacing(1),
      },
      [muiTheme.breakpoints.down('sm')]: {
        marginTop: muiTheme.spacing(6),
      },
    },
    partnerIntro: {
      paddingRight: muiTheme.spacing(6),

      [muiTheme.breakpoints.down('sm')]: {
        backgroundColor: '#fff',
        borderRadius: '4px',
        marginBottom: muiTheme.spacing(3),
        padding: muiTheme.spacing(6.5, 3.75, 5, 3.75),
      },
    },
    partnerSite: {
      marginBottom: muiTheme.spacing(2),

      '& h1, h2, h3, h4, h5, h6': {
        ...typography.subtitle2,
        '&:not(:last-child)': {
          marginBottom: 0,
        },
      },
      '& h1, h2, h3, h4, h5, h6, p': {
        margin: 0,
      },
    },
    root: {
      backgroundColor: '#fff',
      borderRadius: '4px',
      padding: muiTheme.spacing(6.5, 12.5),

      [muiTheme.breakpoints.down('sm')]: {
        backgroundColor: 'transparent',
        padding: 0,
      },
    },
    socialIcon: {
      width: '15px',
      '&.MuiSvgIcon-root': {
        fill: BackgroundColors.dark,
      },
    },
    socialIconButton: {
      marginRight: muiTheme.spacing(2),
      padding: 0,
    },
  }),
  { name: 'GenTPDIntroContent' },
);

export default useStyles;
